import { useTranslation } from '../../translation/TranslationContext';
import useSegments, { SegmentsTranslation, translateSegments } from '../useSegments';

interface UseSegmentOptionsParams {
  isEnabled: boolean;
}

const useSegmentOptions = ({ isEnabled }: UseSegmentOptionsParams) => {
  const { isPortuguese } = useTranslation();
  const [segmentsState] = useSegments({ autoLoad: isEnabled });

  return segmentsState.options.map((option) => ({
    ...option,
    label:
      translateSegments(option.label as keyof SegmentsTranslation, isPortuguese) ?? option.label,
  }));
};

export default useSegmentOptions;
